import { theme } from '@pocketlaw/tetris';
import { css } from 'styled-components';
export const highlightStyles = css `
  .pl-highlight--assistant {
    background-color: ${theme.swatches.magenta[100]};
  }
`;
